import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { IEditableLegalClient } from '../../Interfaces/IEditLegalClient';
import { ILegalClient } from '../../Interfaces/ILegalClient';
import { EmailField } from './fields/Email/EmailField';
import { LegalClientTypeField } from './LegalClientType/LegalClientTypeField';
import { LegalPersonForm } from './LegalPersonForm/LegalPersonForm';
import {
  DeathOptions,
  NaturalPersonForm,
} from './NaturalPersonForm/NaturalPersonForm';
import { UpdateAddressForm } from './UpdateAddressForm/UpdateAddressForm';

interface IProps {
  disableCompanyLegalClient?: boolean;
  disableContactInformation?: boolean;
  deathOptions?: DeathOptions;
  addressOptions?: AddressOptions;
  shouldDisableSaveButton?: (legalClient: ILegalClient) => boolean;
  requireEmail?: boolean;
}

type AddressOptions = {
  title?: string;
  requireFields: {
    street?: boolean;
    streetNumber?: boolean;
  };
  requireAdress: true;
};

export function EditLegalClient({
  disableContactInformation = false,
  disableCompanyLegalClient = false,
  deathOptions,
  addressOptions,
  requireEmail = false,
}: IProps) {
  const { control } = useFormContext<IEditableLegalClient>();
  const idLegalClientType = useWatch<IEditableLegalClient>({
    control,
    name: 'idLegalClientType',
  });

  const isLegalClientNaturalPerson = idLegalClientType === 1;

  return (
    <>
      <Typography variant='caption'>
        Pflichtfelder sind mit einem <b>*</b> angegeben.
      </Typography>

      <Grid container spacing={2} pt={3}>
        {!disableCompanyLegalClient && (
          <>
            <LegalClientTypeField<IEditableLegalClient> name='idLegalClientType' />
            <Grid item xs={9} />
          </>
        )}

        {isLegalClientNaturalPerson ? (
          <NaturalPersonForm deathOptions={deathOptions} />
        ) : (
          <LegalPersonForm />
        )}
      </Grid>

      <Typography sx={{ mt: 3 }} variant='h6'>
        Kontaktinformationen
      </Typography>
      {!requireEmail && (
        <Typography variant='caption'>(optional / empfohlen)</Typography>
      )}
      {!disableContactInformation && (
        <Grid item xs={12} pt={0.75}>
          <EmailField<IEditableLegalClient>
            name='Email'
            required={requireEmail}
          />
        </Grid>
      )}

      <Typography sx={{ mt: 3 }} variant='h6'>
        {addressOptions?.title || 'Adresse'}
      </Typography>

      {!addressOptions?.requireAdress && (
        <Typography variant='caption'>
          (optional, Postleitzahl pflicht)
        </Typography>
      )}

      <UpdateAddressForm
        requireStreet={addressOptions?.requireFields.street}
        requireStreetNumber={addressOptions?.requireFields.streetNumber}
      />
    </>
  );
}
